export const OnboardingGeneralPublicWelcome = () => null
